import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AddRecipeDTO, GetRecipeDTO, UpdateRecipeDTO } from '../admin.dto';
import { Subscription } from 'rxjs';
import {
  AlertController,
  IonModal,
  LoadingController,
  ToastController,
} from '@ionic/angular';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-recipes',
  templateUrl: './recipes.page.html',
  styleUrls: ['./recipes.page.scss'],
})
export class RecipesPage implements OnInit, OnDestroy {
  isLoading = true;
  loadedRecipes: GetRecipeDTO[];
  allRecipes: GetRecipeDTO[];
  recipesSub: Subscription;
  addRecipeSub: Subscription;
  updateRecipeSub: Subscription;
  showImageError = false;
  isPreviewMode = false;
  sendNotif = true;
  isModalOpen = false;
  isUpdate = false;
  selectedName = '';
  selectedIngredients = '';
  selectedHowTo = '';
  uploadedImage = '';
  selectedType = '';
  selectedTimeNeeded = 0;
  selectedNotes = '';
  selectedId = 0;
  servingSize = '';
  totalServing = '';
  calories = 0;
  protein = 0;
  fat = 0;
  fiber = 0;
  carbohydrates = 0;
  petTypeId = 1;
  storage = '';
  description = '';
  filter = 'dogs';
  newDirections: string;
  isAccordionOpen = false;
  originalImage = '';
  @ViewChild('recipeModal') recipeModal: IonModal;
  constructor(
    private adminService: AdminService,
    private toastController: ToastController,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController
  ) { }

  ngOnInit() {
    this.filter = localStorage.getItem('animalFilter') || 'dogs';
    this.getRecipes();
  }
  AddNew() {
    this.ClearFields();
    this.isUpdate = false;
    this.isModalOpen = true;
  }
  ngOnDestroy() {
    if (this.recipesSub) this.recipesSub.unsubscribe();
    if (this.addRecipeSub) this.addRecipeSub.unsubscribe();
    if (this.updateRecipeSub) this.updateRecipeSub.unsubscribe();
  }
  getRecipes() {
    this.isLoading = true;
    this.recipesSub = this.adminService.getAllRecipes().subscribe((recipes) => {
      this.allRecipes = recipes;
      this.filterRecipes();
      this.isLoading = false;
    });
  }

  cancel() {
    if (this.isPreviewMode) {
      this.isPreviewMode = false;
    } else {
      this.isModalOpen = false;
      this.ClearFields();
    }
  }

  onPhotoCaptured(event: { imageUri: string }) {
    this.uploadedImage = event.imageUri;
  }
  ClearFields() {
    this.uploadedImage = '';
    this.showImageError = false;
    this.isPreviewMode = false;
    this.selectedName = '';
    this.selectedIngredients = '';
    this.selectedHowTo = '';
    this.selectedId = 0;
    this.sendNotif = true;
    this.selectedType = '';
    this.selectedTimeNeeded = 0;
    this.selectedNotes = '';
    this.petTypeId = 1;
    this.servingSize = '';
    this.totalServing = '';
    this.calories = 0;
    this.protein = 0;
    this.fat = 0;
    this.fiber = 0;
    this.carbohydrates = 0;
    this.storage = '';
    this.description = '';

  }

  ViewRecipe(recipeId: number) {
    this.loadingCtrl
      .create({
        keyboardClose: true,
        message: 'Please wait...',
      })
      .then((loadingEl) => {
        loadingEl.present();
        this.recipesSub = this.adminService
          .getRecipeById(recipeId)
          .subscribe((recipe: GetRecipeDTO) => {
            this.selectedId = recipe.id;
            this.uploadedImage = recipe.image;
            this.originalImage = recipe.image;
            this.selectedName = recipe.name;
            this.selectedIngredients = recipe.ingredients;
            this.selectedHowTo = recipe.howTo;
            this.isUpdate = true;
            this.isModalOpen = true;
            this.selectedType = recipe.type;
            this.selectedTimeNeeded = recipe.timeNeeded;
            this.selectedNotes = recipe.notes;
            this.petTypeId = recipe.petTypeId;
            this.servingSize = recipe.servingSize;
            this.totalServing = recipe.totalServing;
            this.calories = recipe.calories;
            this.protein = recipe.protein;
            this.fat = recipe.fat;
            this.fiber = recipe.fiber;
            this.carbohydrates = recipe.carbohydrates;
            this.storage = recipe.storage;
            this.description = recipe.description;
            loadingEl.dismiss();
          });
      });
  }

  getNewDirections(howTo: string) {
    const lines = howTo.split('\n');

    const formatted = lines.map(line => {
      const match = line.match(/^(\d+)-\s*(.*)/);
      if (match) {
        const stepNumber = match[1];
        const stepBody = match[2];

        const [title, ...rest] = stepBody.split("–");
        const stepTitle = title.trim();
        const description = rest.join("–").trim(); // preserve inner dashes

        if (description) {
          return `<div class="instruction-line"><strong>Step ${stepNumber}:</strong> ${stepTitle} – ${description}</div>`;
        } else {
          return `<div class="instruction-line"><strong>Step ${stepNumber}:</strong> ${stepTitle}</div>`;
        }
      } else {
        return `<div class="instruction-line">${line}</div>`;
      }
    });

    return formatted.join('\n');
  }

  previewRecipe() {
    if (this.uploadedImage.length == 0) {
      this.showImageError = true;
    } else {
      this.isPreviewMode = true;
    }
  }
  UpdateRecipe() {
    const updatedRecipe: UpdateRecipeDTO = {
      id: this.selectedId,
      name: this.selectedName,
      ingredients: this.selectedIngredients,
      howTo: this.selectedHowTo,
      image: this.uploadedImage,
      notes: this.selectedNotes,
      timeNeeded: this.selectedTimeNeeded,
      type: this.selectedType,
      petTypeId: this.petTypeId,
      servingSize: this.servingSize,
      totalServing: this.totalServing,
      calories: this.calories,
      protein: this.protein,
      fat: this.fat,
      carbohydrates: this.carbohydrates,
      fiber: this.fiber,
      storage: this.storage,
      description: this.description,
    };
    this.loadingCtrl
      .create({
        keyboardClose: true,
        showBackdrop: false,
        message: 'Please Wait...',
      })
      .then(async (loadingEl) => {
        loadingEl.present();
        this.updateRecipeSub = (
          await this.adminService.updateRecipe(updatedRecipe, this.originalImage)
        ).subscribe({
          next: async (isAdded) => {
            if (!isAdded) {
              loadingEl.dismiss();
              this.alertCtrl
                .create({
                  header: 'An Error Occurred',
                  message:
                    'Could not perform this action at the moment. Please try again later.',
                  buttons: [{ text: 'Dismiss' }],
                })
                .then((alerEl) => {
                  loadingEl.dismiss();
                  alerEl.present();
                });
            } else {
              const toast = await this.toastController.create({
                color: 'primary',
                duration: 2000,
                message: 'Recipe updated successfully',
              });
              this.getRecipes();
              loadingEl.dismiss();
              await toast.present();
              this.ClearFields();
              this.isUpdate = false;
              this.isModalOpen = false;
            }
          },
          error: () => loadingEl.dismiss(),
        });
      });
  }

  deleteRecipe(recipeId: number) {
    this.alertCtrl
      .create({
        header: 'Delete Recipe?',
        message: 'Are you sure you want to delete this recipe?',
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
              this.alertCtrl.dismiss();
            },
          },
          {
            text: 'Delete',
            cssClass: 'confirm-delete',
            handler: () => {
              this.performDelete(recipeId);
              this.alertCtrl.dismiss();
            },
          },
        ],
      })
      .then((alertEl) => alertEl.present());
  }

  performDelete(recipeId: number) {
    this.loadingCtrl
      .create({
        keyboardClose: true,
        message: 'Please wait...',
      })
      .then((loadingEl) => {
        loadingEl.present();
        this.originalImage = this.loadedRecipes.find((e) => e.id === recipeId)
          .image;
        this.adminService.deleteRecipe(recipeId, this.originalImage).subscribe({
          next: (res) => {
            if (res) {
              const index = this.loadedRecipes.findIndex(
                (e) => e.id === recipeId
              );
              this.loadedRecipes.splice(index, 1);
            }
            loadingEl.dismiss();
          },
          error: () => {
            loadingEl.dismiss();
          },
        });
      });
  }

  AddRecipe() {
    this.loadingCtrl
      .create({
        keyboardClose: true,
        showBackdrop: false,
        message: 'Please Wait...',
      })
      .then(async (loadingEl) => {
        loadingEl.present();
        const recipe: AddRecipeDTO = {
          name: this.selectedName,
          ingredients: this.selectedIngredients,
          howTo: this.selectedHowTo,
          image: this.uploadedImage,
          sendNotification: this.sendNotif,
          notes: this.selectedNotes,
          timeNeeded: this.selectedTimeNeeded,
          type: this.selectedType,
          petTypeId: +this.petTypeId,
          servingSize: this.servingSize,
          totalServing: this.totalServing,
          calories: this.calories,
          protein: this.protein,
          fat: this.fat,
          carbohydrates: this.carbohydrates,
          fiber: this.fiber,
          storage: this.storage,
          description: this.description,
        };
        this.addRecipeSub = (
          await this.adminService.addRecipe(recipe)
        ).subscribe({
          next: async (isAdded) => {
            if (!isAdded) {
              loadingEl.dismiss();
              this.alertCtrl
                .create({
                  header: 'An Error Occurred',
                  message:
                    'Could not perform this action at the moment. Please try again later.',
                  buttons: [{ text: 'Dismiss' }],
                })
                .then((alerEl) => {
                  loadingEl.dismiss();
                  alerEl.present();
                });
            } else {
              const toast = await this.toastController.create({
                color: 'primary',
                duration: 2000,
                message: 'Recipe added successfully',
              });
              this.getRecipes();
              loadingEl.dismiss();
              await toast.present();
              this.isPreviewMode = false;
              this.cancel();
            }
          },
          error: () => loadingEl.dismiss(),
        });
      });
  }
  filterRecipes() {
    if (this.filter === 'dogs') {
      this.loadedRecipes = this.allRecipes.filter(
        (recipe) => recipe.petTypeId === 1
      );
      localStorage.setItem('animalFilter', this.filter);
    } else if (this.filter === 'cats') {
      this.loadedRecipes = this.allRecipes.filter(
        (recipe) => recipe.petTypeId === 2
      );
      localStorage.setItem('animalFilter', this.filter);
    } else {
      this.loadedRecipes = this.allRecipes;
    }
  }
  toggleAccordion(event, detail?: CustomEvent) {
    this.isAccordionOpen = event.detail.value === 'first';
  }
}
